import LocatorAction from './LocatorAction';
import SaleAction from './SaleAction';
import SaleDetailModel from './SaleDetailModel';
import SaleDetailRenderer from './SaleDetailRenderer';
import LocatorDetailModel from './LocatorDetailModel';
import LocatorDetailRenderer from './LocatorDetailRenderer';
export default {
  install(molten) {
    molten.addPlugin('Action', LocatorAction);
    molten.addPlugin('Action', SaleAction);

    // sale detail
    molten.addPlugin('Model', {
      type: SaleDetailModel.TYPE,
      model: SaleDetailModel
    });
    molten.addPlugin('Detail', {
      name: 'Reconcile Locator Position',
      objectType: 'sale',
      create: () => {
        const json = SaleDetailModel.create('sale');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: SaleDetailModel.TYPE,
      renderer: SaleDetailRenderer
    });

    // locator detail
    molten.addPlugin('Model', {
      type: LocatorDetailModel.TYPE,
      model: LocatorDetailModel
    });
    molten.addPlugin('Detail', {
      name: 'Request Locator Position',
      objectType: 'locator',
      create: () => {
        const json = LocatorDetailModel.create('locator');
        return json;
      },
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: LocatorDetailModel.TYPE,
      renderer: LocatorDetailRenderer
    });
  }
};